import TitleHeader from '@/components/TitleHeader/TitleHeader.vue';

import StoreModuleMixin from '@/mixins/StoreModuleMixin';
import { ContestEntry } from '@/modules/ContestFormModule/ContestForm/ContestForm.types';

import ContestForm from '@/modules/ContestFormModule/ContestForm/ContestForm.vue';
import {
  ContestFormModuleState,
  SUBMIT_FORM
} from '@/modules/ContestFormModule/ContestFormModule.store';

import {getComponentProps} from '@/utils/vueUtils';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import { ContestFormViewModel } from './ContestFormModule.types';

@Component({
  components: {
    ContestForm,
    TitleHeader,
  },
  props: getComponentProps<ContestFormViewModel>({
    Tag: '',
    ThankYouText: 'Thank you',
    HeaderText: 'Click here to register.',
    BottomText: '',
  }),
})

export default class ContestFormModule extends Mixins(StoreModuleMixin) {
  state!: ContestFormModuleState;
  submitForm: (model: ContestEntry) => void = this.getAction(SUBMIT_FORM);

  get titleHeaderData() {
    return this.state.IsSubmitted
      ? {
        Title: this.$props.p.ThankYouText,
        Link: {},
        Text: "",
        Center: true,
      }
      :
      {
        Title: "",
        Text: this.$props.p.HeaderText + " Fields with an asterisk (*) are required.",
        Link: {},
        Center: false,
      };
  }

  mounted() {
  }
}
